module.exports = __webpack_public_path__ + "files/af2cd6adb95887847bde9aa79c275e08.png";